/**
 * @desc Timeline Chart
 *
 * Usage: <cs-timeline cs-timeline-data="@data" cs-timeline-config="@config"></cs-timeline>
 *
 *      @data   Array of data (one property should be a timestamp in ms)
 *      @config Configuration object for timeline (See csTimelineChart.getConfigurableProperties for used properties)
 *              Ex: {
 *                  plural: 'events',
 *                  timeProperty: 'eventTime',
 *                  label2Accessor: function(record){
 *                      return record.eventName;
 *                  }
 *              }
 */
;(function () {
  angular.module('contrast.timeline').directive('csTimeline', [csTimeline])

  function csTimeline() {
    return {
      restrict: 'E',
      scope: {
        csTimelineData: '=',
        csTimelineConfig: '=',
        csTimelineShow: '=',
        loading: '='
      },
      templateUrl: 'views/common/cs-timeline.html',
      controller: 'csTimelineCtrl',
      controllerAs: 'timelineCtrl',
      link: link
    }

    function link($scope, $element, $attrs, controller) {
      $scope.$watch('csTimelineData', function (newVal) {
        if (angular.isObject(newVal)) {
          var parent = $element.parent(),
            timelineContainer = $element.find('.cs-timeline')

          controller.activate($scope, parent, timelineContainer)
        }
      })
    }
  }
})()
